import locale from "localization";

export const groupsColumns = [
  { key: "name", text: locale.name, width: "30%" },
  { key: "status", text: locale.status, width: "30%" },
  { key: "action", text: locale.action, width: "5%" },
];
